export default __webpack_public_path__ + "static/Tolerance-577d71cf65153d10b93e5cdb0e405736.svg";